// Eventos del calendario público de Google que se muestran en /calendario
// junto a los de la temporada. Se consulta directamente la Google Calendar
// API desde el navegador: el calendario tiene que ser público y la API key
// estar restringida al dominio de la web (referrer HTTP). Configuración en
// .env (se fija en el build): REACT_APP_GOOGLE_CALENDAR_ID y
// REACT_APP_GOOGLE_CALENDAR_API_KEY.
const CALENDAR_ID = process.env.REACT_APP_GOOGLE_CALENDAR_ID;
const API_KEY = process.env.REACT_APP_GOOGLE_CALENDAR_API_KEY;

export const googleCalendarConfigurado = Boolean(CALENDAR_ID);

// Añade el calendario a la cuenta de Google del usuario; a partir de ahí
// Google le sincroniza los eventos nuevos solo.
export const urlSuscripcionGoogle = () =>
  `https://calendar.google.com/calendar/u/0/r?cid=${encodeURIComponent(CALENDAR_ID)}`;

// Feed iCal para Apple Calendar, Outlook y similares.
export const urlSuscripcionIcal = () =>
  `webcal://calendar.google.com/calendar/ical/${encodeURIComponent(CALENDAR_ID)}/public/basic.ics`;

// Los eventos de todo el día traen `date` ('YYYY-MM-DD') y su `end` es
// exclusivo; los que tienen hora traen `dateTime` ISO con su propio offset,
// así que el día se lee tal cual, sin pasar por Date (evita desfases).
const diaDe = (momento) => (momento.date ?? momento.dateTime).slice(0, 10);

const restarUnDia = (iso) => {
  const [a, m, d] = iso.split('-').map(Number);
  return new Date(Date.UTC(a, m - 1, d - 1, 12)).toISOString().slice(0, 10);
};

// Mismo formato que devuelve `/calendario-eventos` (ver construirFilasCalendario).
const aEventoTemporada = (e) => {
  const fechaInicio = diaDe(e.start);
  const finDia = diaDe(e.end);
  const fechaFin = e.end.date ? restarUnDia(finDia) : finDia;
  return {
    id: `google-${e.id}`,
    tipo: 'EVENTO',
    titulo: e.summary || '(Sin título)',
    descripcion: e.location || undefined,
    fecha_inicio: fechaInicio,
    fecha_fin: fechaFin < fechaInicio ? fechaInicio : fechaFin,
    externo: true,
  };
};

// `desde`/`hasta`: 'YYYY-MM-DD' (hasta, inclusive).
export const getEventosGoogleCalendar = async (desde, hasta) => {
  const params = new URLSearchParams({
    key: API_KEY,
    singleEvents: 'true',
    orderBy: 'startTime',
    maxResults: '2500',
    timeMin: `${desde}T00:00:00Z`,
    timeMax: `${hasta}T23:59:59Z`,
  });
  const res = await fetch(
    `https://www.googleapis.com/calendar/v3/calendars/${encodeURIComponent(CALENDAR_ID)}/events?${params}`,
  );
  if (!res.ok) throw new Error(`Google Calendar respondió ${res.status}`);
  const { items = [] } = await res.json();
  return items.filter((e) => e.status !== 'cancelled' && e.start && e.end).map(aEventoTemporada);
};
